<template>
  <div>
    <h1 style="margin-top: 30px">Terms & conditions <router-link :to="{ name: 'termsPage', params: { }}">+ Publish new version</router-link></h1>
    <div id="news-table" class="data-table" border="1">
      <div class="header">
        <div>ID</div><div>Date</div><div>Version</div><div>Country</div><div>Title</div>
      </div>
      <div v-for="entry in news" v-bind:key="entry.id" class="row">
        <div class="cell">{{entry.id}}</div>
        <div class="cell">
          {{dayjs(entry.date._seconds * 1000).format('YYYY-MM-DD HH:mm')}}
        </div>
        <div class="cell">{{entry.version}}</div>
        <div class="cell">
          {{entry.country}}
        </div>
        <div class="cell"><router-link :to="{ name: 'termsVersionPage', params: { id: entry.id }}">{{entry.title}}</router-link></div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="less">
#news-table, #articles-table {
  margin-top: 30px;
  grid-template-columns: auto auto auto auto auto;
}
.cell {
  text-align: left;
  padding-left: 10px
}
</style>

<script>
import api from '../services/api';
import dayjs from 'dayjs';

export default {
  name: 'news',
    data: function() {
    return {
      news: [],
      articles: [],
      dayjs: dayjs,
    }
  },
  created: async function() {
    // console.log(translations['skill.electricalInstallation.title']);
    this.news = await api.getTerms();
  }
}
</script>
